import { DirectoryFolder, NestedFolders } from '../types';

export const convertToTreeData = (folder: NestedFolders): DirectoryFolder => ({
  key: folder.id,
  title: folder.name,
  value: folder.id,
  children: folder?.nested_folders?.map(convertToTreeData),
});
